import { ComponentType } from '@angular/cdk/portal';

import { BaseModel } from '../../core/abstractions/base.model';
import { ButtonMapper } from '../../core/utils/mappers/button.mapper';

export class CommandModel extends BaseModel {
    name: string;
    button = ButtonMapper.generic;
    component: ComponentType<any>;
    showOnModal = false;
    modalWidth?: string;
    isRequest = false;

    constructor(init: Partial<CommandModel>) {
        super();
        Object.assign(this, init);
    }
}
